/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { OrderCompletionStatusEnumType } from "./OrderCompletionStatusEnum"
import { ProofOfDeliveryPhotoDtoModel, ProofOfDeliveryPhotoDtoModelType } from "./ProofOfDeliveryPhotoDtoModel"
import { ProofOfDeliveryPhotoDtoModelSelector } from "./ProofOfDeliveryPhotoDtoModel.base"
import { ScannedPackageDtoModel, ScannedPackageDtoModelType } from "./ScannedPackageDtoModel"
import { ScannedPackageDtoModelSelector } from "./ScannedPackageDtoModel.base"
import { SignatureDtoModel, SignatureDtoModelType } from "./SignatureDtoModel"
import { SignatureDtoModelSelector } from "./SignatureDtoModel.base"
import { RootStoreType } from "./index"


/**
 * OrderEventLogDtoBase
 * auto generated base class for the model OrderEventLogDtoModel.
 */
export const OrderEventLogDtoModelBase = ModelBase
  .named('OrderEventLogDto')
  .props({
    __typename: types.optional(types.literal("OrderEventLogDto"), "OrderEventLogDto"),
    orderUuid: types.identifier,
    eventUuid: types.union(types.undefined, types.string),
    routeUuid: types.union(types.undefined, types.null, types.string),
    actionUuid: types.union(types.undefined, types.null, types.string),
    userUuid: types.union(types.undefined, types.null, types.string),
    status: types.union(types.undefined, OrderCompletionStatusEnumType),
    date: types.union(types.undefined, types.string),
    reason: types.union(types.undefined, types.null, types.string),
    photos: types.union(types.undefined, types.null, types.array(types.late((): any => ProofOfDeliveryPhotoDtoModel))),
    scannedPackages: types.union(types.undefined, types.null, types.array(types.late((): any => ScannedPackageDtoModel))),
    notes: types.union(types.undefined, types.null, types.string),
    signature: types.union(types.undefined, types.null, types.late((): any => SignatureDtoModel)),
    lastUpdatedTimestamp: types.union(types.undefined, types.null, types.string),
    reattemptRequestDate: types.union(types.undefined, types.null, types.string),
    latitude: types.union(types.undefined, types.null, types.number),
    longitude: types.union(types.undefined, types.null, types.number),
    distanceFromOrder: types.union(types.undefined, types.null, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrderEventLogDtoModelSelector extends QueryBuilder {
  get orderUuid() { return this.__attr(`orderUuid`) }
  get eventUuid() { return this.__attr(`eventUuid`) }
  get routeUuid() { return this.__attr(`routeUuid`) }
  get actionUuid() { return this.__attr(`actionUuid`) }
  get userUuid() { return this.__attr(`userUuid`) }
  get status() { return this.__attr(`status`) }
  get date() { return this.__attr(`date`) }
  get reason() { return this.__attr(`reason`) }
  get notes() { return this.__attr(`notes`) }
  get lastUpdatedTimestamp() { return this.__attr(`lastUpdatedTimestamp`) }
  get reattemptRequestDate() { return this.__attr(`reattemptRequestDate`) }
  get latitude() { return this.__attr(`latitude`) }
  get longitude() { return this.__attr(`longitude`) }
  get distanceFromOrder() { return this.__attr(`distanceFromOrder`) }
  photos(builder: string | ProofOfDeliveryPhotoDtoModelSelector | ((selector: ProofOfDeliveryPhotoDtoModelSelector) => ProofOfDeliveryPhotoDtoModelSelector) | undefined) { return this.__child(`photos`, ProofOfDeliveryPhotoDtoModelSelector, builder) }
  scannedPackages(builder: string | ScannedPackageDtoModelSelector | ((selector: ScannedPackageDtoModelSelector) => ScannedPackageDtoModelSelector) | undefined) { return this.__child(`scannedPackages`, ScannedPackageDtoModelSelector, builder) }
  signature(builder: string | SignatureDtoModelSelector | ((selector: SignatureDtoModelSelector) => SignatureDtoModelSelector) | undefined) { return this.__child(`signature`, SignatureDtoModelSelector, builder) }
}
export function selectFromOrderEventLogDto() {
  return new OrderEventLogDtoModelSelector()
}

export const orderEventLogDtoModelPrimitives = selectFromOrderEventLogDto().orderUuid.eventUuid.routeUuid.actionUuid.userUuid.status.date.reason.notes.lastUpdatedTimestamp.reattemptRequestDate.latitude.longitude.distanceFromOrder
